import { Form, Input, Button } from "antd";
import contactus from "../../assets/contactus.jpeg";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const ContactScreen = () => {
  return (
    <div className="w-full bg-gray-50">

      {/* HERO */}
      <div className="relative h-[260px] sm:h-[340px]">
        <img
          src={contactus}
          alt="Contact"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-white">
          <h1 className="text-4xl sm:text-5xl font-semibold">Contact Us</h1>
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">

          {/* LEFT – FORM */}
          <Form
            layout="vertical"
            className="
              bg-primary-900 rounded-xl shadow-lg p-8

              [&_.ant-form-item-label>label]:text-primary-50
              [&_.ant-input]:text-primary-800
              [&_.ant-input]:border-primary-800
              [&_.ant-input]:rounded-md

              [&_.ant-input-textarea]:text-primary-800
              [&_.ant-input-textarea]:border-primary-800
              [&_.ant-input-textarea]:rounded-md
            "
          >
            <Form.Item label="Your Name" name="name" rules={[{ required: true }]}>
              <Input placeholder="Full Name" />
            </Form.Item>

            <Form.Item label="Your Email" name="email" rules={[{ required: true, type: "email" }]}>
              <Input placeholder="Email Address" />
            </Form.Item>

            <Form.Item label="Subject" name="subject">
              <Input placeholder="Subject" />
            </Form.Item>

            <Form.Item label="Your Message" name="message" rules={[{ required: true }]}>
              <Input.TextArea rows={4} placeholder="Message" />
            </Form.Item>

              <div className="flex justify-center">
               <Button  htmlType="submit"
              className="bg-primary-500 hover:bg-primary-600 text-white px-8 rounded-md"
            >
              Send Message
            </Button>
            </div>
             
          </Form>

          {/* RIGHT – CONTACT INFO */}
          <div>
            <span className="text-sm text-primary-500 font-semibold uppercase">
              Contact Us
            </span>
            <h2 className="text-primary-800 text-3xl font-bold mt-2 mb-4">
              Get In Touch
            </h2>
            <p className="text-primary-600 mb-8">
              Feel free to reach out to us. We’re always happy to help and
              answer your questions.
            </p>

            <div className="space-y-5 text-primary-700">

              <div className="flex items-start gap-4">
                <WhatsAppIcon className="text-primary-500" />
                <div>
                  <p className="font-medium">Call / WhatsApp</p>
                  <p className="text-sm">+91 12345 67890</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <EmailIcon className="text-primary-500" />
                <div>
                  <p className="font-medium">Email Us</p>
                  <p className="text-sm">hello@eelaacafe.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <LanguageIcon className="text-primary-500" />
                <div>
                  <p className="font-medium">Website</p>
                  <p className="text-sm">www.eelaacafe.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <LocationOnIcon className="text-primary-500" />
                <div>
                  <p className="font-medium">Address</p>
                  <p className="text-sm">
                    Satara, Maharashtra, India
                  </p>
                </div>
              </div>
            </div>

            {/* SOCIAL */}
            <div className="flex gap-4 mt-8">
              <a href="https://www.instagram.com/eelaacafe" target="_blank" rel="noreferrer">
                <InstagramIcon className="text-gray-600 hover:text-pink-500 transition" />
              </a>
              <a href="https://wa.me/911234567890" target="_blank" rel="noreferrer">
                <WhatsAppIcon className="text-gray-600 hover:text-green-500 transition" />
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* MAP */}
      <div className="h-[360px]">
        <iframe
          title="Location"
          src="https://www.google.com/maps?q=Satara,Maharashtra&output=embed"
          className="w-full h-full border-0"
          loading="lazy"
        />
      </div>

    </div>
  );
};

export default ContactScreen;
